import { connect } from 'react-redux';

import getUsersManagementState from 'dux/usersManagement/selectors';
import { actionCreators as actions } from 'dux/usersManagement';

import UsersPage from './UsersPage';

const mapStateToProps = (state) => ({
  ...getUsersManagementState(state),
});

const mapDispatchToProps = {
  getUserInvitesState: actions.getUserInvitesState,
  getUsersState: actions.getUsersState,
  getUsersPoll: actions.getUsersPoll,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);
